import { formatDate } from "../../../common/hooks/Formatter";
import {
  RAPID_RESPONSE_FILTER_DATERANGE,
  FILTER_NETWORK,
  FILTER_DC,
  LOCATION,
  FILTER_PRODUCTS,
  FILTER_CUSTOMERS,
  FILTER_DATERANGE,
  SET_PAST_DUE_CHECK,
  APPLY_FILTER,
  SAVE_FILTER,
  DELETE_FILTER,
  SET_FILTER,
  FILTER_PL3,
  FILTER_CL6,
  FILTER_DIVISION,
  FILTER_SAVEDNAMES,
  FILTER_NAMES,
  FILTER_PERIOD_TYPE,
  SET_FILTER_LIST,
  SET_FILTER_DIVISION,
  SET_FILTER_PL3,
  SET_FILTER_PRODUCTS,
  SET_FILTER_CUSTOMER,
  SET_ACTIVE_FLAG,
  FROM_STATE,
  TO_STATE,
  FROM_ZIP,
  TO_ZIP,
  LANE,
  TEMPERATURE,
  FAC_ID,
  FAC_TYPE,
  SET_SCENARIO_FLAG,
  SET_ACTIVE_SCENARIOS,
  SET_ACTIVE_EVENTS_COUNT,
  SET_GRAPH_OR_MAP_VIEW,
  SET_SCENARIOS,
  SET_SELECTED_SCENARIOS,
  SET_RECOM_FLAG,
  CP_DATERANGE,
  DIP_DATERANGE,
  SHOW_ALERT_GRAPH,
  SET_UNIT_VALUE,
  SET_SELECTED_NETWORKS,
  SET_DETAILS_SWITCH,
  SET_DETENTION_DATERANGE,
  SET_INCLUDE_NPOOS,
  SET_POOS_RADIO_BUTTON,
  SET_IOFPB_RADIO_BUTTON,
  SET_INCOTERM,
  FGS_DATERANGE,
} from "../../Actions/Types";
const calculateFourWeeksAgoDate = (date) => {
  const fourWeeksAgo = new Date(date);
  fourWeeksAgo.setDate(fourWeeksAgo.getDate() - 28);
  return fourWeeksAgo.toISOString().slice(0, 10);
};

const addAMonthToCurrentDate = () => {
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() + 1);
  return currentDate.toISOString().slice(0, 10);
};

const subtractTwoMonthsFromCurrentDate = () => {
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 2);
  return currentDate.toISOString().slice(0, 10);
};

const endDate = new Date().toISOString().slice(0, 10);
const startDate = calculateFourWeeksAgoDate(new Date());

const todaysDate = new Date().toISOString().slice(0, 10);
const nextMonthDate = addAMonthToCurrentDate();
const twoMonthsBeforeDate = subtractTwoMonthsFromCurrentDate();

// console.log("twoMonthsBeforeDate: ", twoMonthsBeforeDate)

const initialState = {
  Network: [],
  DC: [],
  Products: [],
  Customers: [],
  PL3: [],
  CL6: [],
  Division: [],
  filterName: [],
  periodType: "WOW",
  SavedFilterNameList: [],
  Date: [startDate, endDate],
  rapidResponseDates: [todaysDate, nextMonthDate],
  dateRangeCP: [todaysDate, nextMonthDate],
  dateRangeDIP: [todaysDate, nextMonthDate],
  dateRangeDetention: [twoMonthsBeforeDate, todaysDate],
  dateRangeFGS: [todaysDate, nextMonthDate],
  applyFilter: [],
  filters: [],
  filtersList: [{}],
  filteredList: { Network: [], DC: [], PL3: [], division: [] },
  filteredDivision: { data: [] },
  filteredPL3: { data: [] },
  filteredProducts: { product: [] },
  filteredCustomers: { customer: [] },
  pastDueCheck: [],
  activeFlag: 1,
  scenarios: [],
  recomFlag: "All",
  activeEventsCount: 0,
  activeScenarios: [],
  selectedScenarios: [],
  selectedNetworks: [],
  graphOrMapView: "Graph View",
  fromState: [],
  toState: [],
  fromZip: [],
  toZip: [],
  lane: [],
  Temperature: [],
  facType: [],
  facId: [],
  location: [],
  scenarioValue: "",
  showAlertGraph: false,
  unit: "Dollars",
  detailsSwitch: false,
  includeNPOOS: false,
  radioButtonPOOS: "National",
  radioButtonIOFPB: "Customer Group",
  incoTerm: "All",
};

const FilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_NETWORK:
      return {
        ...state,
        Network: action.payload,
      };
    case FILTER_PERIOD_TYPE:
      return {
        ...state,
        periodType: action.payload,
      };
    case FILTER_DC:
      return {
        ...state,
        DC: action.payload,
      };
    case FILTER_PRODUCTS:
      return {
        ...state,
        Products: action.payload,
      };

    case FILTER_CUSTOMERS:
      return {
        ...state,
        Customers: action.payload,
      };

    case FILTER_PL3:
      return {
        ...state,
        PL3: action.payload,
      };
    case FILTER_CL6:
      return {
        ...state,
        CL6: action.payload,
      };
    case FILTER_DIVISION:
      return {
        ...state,
        Division: action.payload,
      };
    case FILTER_SAVEDNAMES:
      return {
        ...state,
        SavedFilterNameList: action.payload,
      };
    case FILTER_NAMES:
      return {
        ...state,
        filterName: action.payload,
      };
    case FILTER_DATERANGE:
      return {
        ...state,
        Date: action.payload,
      };
    case RAPID_RESPONSE_FILTER_DATERANGE:
      return {
        ...state,
        rapidResponseDates: action.payload,
      };
    case CP_DATERANGE:
      return {
        ...state,
        dateRangeCP: action.payload,
      };
    case DIP_DATERANGE:
      return {
        ...state,
        dateRangeDIP: action.payload,
      };
    case SET_DETENTION_DATERANGE:
      return {
        ...state,
        dateRangeDetention: action.payload,
      };
    case APPLY_FILTER:
      return {
        ...state,
        applyFilter: action.payload,
      };
    case SAVE_FILTER:
      return {
        ...state,
        filters: [...state.filters, action.payload],
      };
    case DELETE_FILTER:
      return {
        ...state,
        filters: state.filters.filter((_, index) => index !== action.payload),
      };
    case SET_FILTER:
      return {
        ...state,
        filtersList: action.payload,
      };
    case SET_FILTER_LIST:
      return {
        ...state,
        filteredList: action.payload,
      };
    case SET_FILTER_DIVISION:
      return {
        ...state,
        filteredDivision: action.payload,
      };
    case SET_FILTER_PL3:
      return {
        ...state,
        filteredPL3: action.payload,
      };
    case SET_FILTER_PRODUCTS:
      return {
        ...state,
        filteredProducts: action.payload,
      };
    case SET_FILTER_CUSTOMER:
      return {
        ...state,
        filteredCustomers: action.payload,
      };

    case SET_PAST_DUE_CHECK:
      return {
        ...state,
        pastDueCheck: action.payload,
      };
    case SET_ACTIVE_FLAG:
      return {
        ...state,
        activeFlag: action.payload,
      };
    case SET_INCOTERM:
      return {
        ...state,
        incoTerm: action.payload,
      };
    case SET_SCENARIOS:
      return {
        ...state,
        scenarios: action.payload,
      };
    case SET_SELECTED_SCENARIOS:
      return {
        ...state,
        selectedScenarios: action.payload,
      };
    case SET_SELECTED_NETWORKS:
      return {
        ...state,
        selectedNetworks: action.payload,
      };
    case SET_RECOM_FLAG:
      return {
        ...state,
        recomFlag: action.payload,
      };
    case SET_GRAPH_OR_MAP_VIEW:
      return {
        ...state,
        graphOrMapView: action.payload,
      };
    case SET_ACTIVE_SCENARIOS:
      return {
        ...state,
        activeScenarios: action.payload,
      };
    case SET_ACTIVE_EVENTS_COUNT:
      return {
        ...state,
        activeEventsCount: action.payload,
      };

    case SET_SCENARIO_FLAG:
      return {
        ...state,
        scenarioValue: action.payload,
      };
    case FROM_STATE:
      return {
        ...state,
        fromState: action.payload,
      };
    case TO_STATE:
      return {
        ...state,
        toState: action.payload,
      };
    case FROM_ZIP:
      return {
        ...state,
        fromZip: action.payload,
      };
    case TO_ZIP:
      return {
        ...state,
        toZip: action.payload,
      };
    case LANE:
      return {
        ...state,
        lane: action.payload,
      };
    case TEMPERATURE:
      return {
        ...state,
        Temperature: action.payload,
      };
    case FAC_ID:
      return {
        ...state,
        facId: action.payload,
      };
    case LOCATION:
      return {
        ...state,
        location: action.payload,
      };
    case FAC_TYPE:
      return {
        ...state,
        facType: action.payload,
      };
    case SHOW_ALERT_GRAPH:
      return {
        ...state,
        showAlertGraph: action.payload,
      };
    case SET_UNIT_VALUE:
      return {
        ...state,
        unit: action.payload,
      };
    case SET_DETAILS_SWITCH:
      return {
        ...state,
        detailsSwitch: action.payload,
      };
    case SET_INCLUDE_NPOOS:
      return {
        ...state,
        includeNPOOS: action.payload,
      };
    case SET_POOS_RADIO_BUTTON:
      return {
        ...state,
        radioButtonPOOS: action.payload,
      };
    case SET_IOFPB_RADIO_BUTTON:
      return {
        ...state,
        radioButtonIOFPB: action.payload,
      };
    case FGS_DATERANGE:
      return {
        ...state,
        dateRangeFGS: action.payload,
      };
    default:
      return state;
  }
};

export default FilterReducer;
